import { useEffect, useState } from "react"
import { DataListType, FilterStateType } from "../types";
import { useApi } from "utils";
import { SuccessFetch } from "types";

export function useList({ department, jobpos, location, date_start, date_end, keyword, type }: FilterStateType) {


  const api = useApi()
  const [data, setData] = useState<DataListType[]>([])
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {};
  if (department) params.department_id = department;
  if (jobpos) params.job_position_id = jobpos;
  if (location) params.location_id = location;
  if (date_start) params.date_start = date_start;
  if (date_end) params.date_end = date_end;
  if (keyword) params.search = keyword;

  const url = type === "prev" ? "/employee/data_schedule_previous" : "/employee/data_schedule"

  const fetchingData = () => api.get(url, { params })
  const fetchData = () => {
    setLoading(true)

    fetchingData()
    .then((res: SuccessFetch<{ payload: DataListType[] }>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }
  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [ department, jobpos, location, date_start, date_end, keyword, type ])

  return { data, isLoading, refetch }
}